import axios from 'axios';

const getKS = () => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ apiVersion: process.env.REACT_APP_KALTURA_API_VERSION, partnerId: process.env.REACT_APP_PARTNER_ID }),
    url: `${process.env.REACT_APP_KALTURA_SERVICE_URL}/service/OTTUser/action/anonymousLogin`,
  };
  return axios(requestOptions);
};

const getMediaInfo = (ks, mediaID) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify({
      ks,
      apiVersion: process.env.REACT_APP_KALTURA_API_VERSION,
      assetReferenceType: 'media',
      id: mediaID,
    }),
    url: `${process.env.REACT_APP_KALTURA_SERVICE_URL}/service/asset/action/get`,
  };
  return axios(requestOptions);
};

export const kalturaServices = {
  getKS,
  getMediaInfo,
};
